<template>
	<div class="multipleStoreData">
		<div class="heading">
			<h4 class="text-xl text-app-dashboard-heading">
				Ford
			</h4>
			<p class="text-sm text-amp-heading2 py-1">
				{{ today }}
			</p>
		</div>
		<div class="tab">
			<div class="flex justify-between">
				<div>
					<p class="lable text-sm">
						Date
					</p>
					<el-date-picker v-model="date" type="date" placeholder="Pick a day">
					</el-date-picker>
				</div>
				<div>
					<p class="lable text-sm">
						Location
					</p>
					<el-select
						v-model="store_name"
						style="max-width: 250px"
						placeholder="Select Store"
					>
						<el-option
							v-for="(item, index) in store_list"
							:key="index"
							:value="item.id"
							:label="item.name"
						>
							{{ item.name }}
						</el-option>
					</el-select>
				</div>
				<div>
					<p class="lable text-sm">
						View
					</p>
					<el-select
						v-model="store_name"
						style="max-width: 250px"
						placeholder="Select Store"
					>
						<el-option
							v-for="(item, index) in store_list"
							:key="index"
							:value="item.id"
							:label="item.name"
						>
							{{ item.name }}
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		<!-- <div class="card-title w-full">
			<div class="flex justify-between items-center">
				<div class="text-center">
					<p class="text-grey-darker">Sales</p>
					<p class="font-bold">64,902</p>
				</div>
				<div class="text-center">
					<p class="text-grey-darker">Target</p>
					<p class="font-bold">64,902</p>
				</div>
				<div class="text-center">
					<p class="text-grey-darker">Achievement</p>
					<p class="font-bold">
						64,902 <span class="text-red ml-4 text-xs">-14.5%</span>
					</p>
				</div>
				<div class="text-center">
					<p class="text-grey-darker">Target Hit Probability</p>
					<p class="font-bold text-red">64,902</p>
				</div>
				<div class="text-center">
					<el-button type="warning" size="small">Action</el-button>
				</div>
			</div>
		</div> -->
		<el-row :gutter="20">
			<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="lunch">
					<div class="">
						<div class="text-xs pt-4 pl-4">Lunch - 12.30 pm to 3:30 pm</div>
						<div class="flex justify-between items-center mt-4">
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Sales</p>
								<p class="font-bold">39,530</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Target</p>
								<p class="font-bold">45,000</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">&nbsp;</p>
								<p class="font-bold">
									87.5%
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="graph-heading">
						<p class="heading">Lunch - 12.30 pm to 3:30 pm</p>
						<!-- <el-button type="warning" size="mini" @click="openPopup"
							>View Hourly</el-button
						> -->
						<el-select
							v-model="store_name"
							style="max-width: 180px"
							size="mini"
							placeholder="Select Store"
						>
							<el-option
								v-for="(item, index) in store_list"
								:key="index"
								:value="item.id"
								:label="item.name"
							>
								{{ item.name }}
							</el-option>
						</el-select>
					</div>
					<SingleLunchGraph :graph-details="graphDetails" />
					<div class="text-right bg-grey-light p-2">
						<el-button type="warning" size="mini" @click="openTable('lunch')">{{
							lunchTable ? "Hide" : "View Details"
						}}</el-button>
					</div>
				</div>
				<div class="text-right">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</el-col>
			<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="lunch">
					<div class="">
						<p class="text-xs pt-4 pl-4">Day - {{ today }}</p>
						<div class="flex justify-between items-center mt-4">
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Sales</p>
								<p class="font-bold">64,902</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Target</p>
								<p class="font-bold">64,902</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">&nbsp;</p>
								<p class="font-bold">
									87%
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="graph-heading">
						<p class="heading">Day - {{ today }}</p>
						<!-- <el-button type="warning" size="mini" @click="openPopup"
							>View Hourly</el-button
						> -->
						<el-select
							v-model="store_name"
							style="max-width: 180px"
							size="mini"
							placeholder="Select Store"
						>
							<el-option
								v-for="(item, index) in store_list"
								:key="index"
								:value="item.id"
								:label="item.name"
							>
								{{ item.name }}
							</el-option>
						</el-select>
					</div>
					<SingleLunchGraph :graph-details="graphDetails" />
					<div class="text-right bg-grey-light p-2">
						<el-button type="warning" size="mini" @click="openTable('day')">{{
							dayTable ? "Hide" : "View Details"
						}}</el-button>
					</div>
				</div>
				<div class="text-right">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</el-col>
		</el-row>
		<div v-if="lunchTable || dayTable" class="card">
			<div class="graph-heading p-2">
				<p class="heading">Day - {{ today }}</p>
			</div>
			<table class="table">
				<thead>
					<tr>
						<th>Store Name</th>
						<th>Sales</th>
						<th>Forecast</th>
						<th>Target</th>
						<th>Last Period</th>
						<th>Achievement</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Total</td>
						<td>12,052</td>
						<td>10,000</td>
						<td>8523</td>
						<td>13.451</td>
						<td>120.05%</td>
					</tr>
					<tr v-for="(item, index) in graphDetails" :key="index">
						<td style="color: #2c9bce; font-weight: bold">{{ item.name }}</td>
						<td>12,052</td>
						<td>10,000</td>
						<td>8523</td>
						<td>13.451</td>
						<td>120.05%</td>
					</tr>
				</tbody>
			</table>
		</div>
		<el-row :gutter="20">
			<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="lunch">
					<div class="">
						<p class="text-xs pt-4 pl-4">Weekly - 26 April to 3 May 2020</p>
						<div class="flex justify-between items-center mt-4">
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Sales</p>
								<p class="font-bold">1,62,255</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Target</p>
								<p class="font-bold">8,40,000</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">&nbsp;</p>
								<p class="font-bold">
									87%
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="graph-heading">
						<p class="heading">Weekly - 26 April to 3 May 2020</p>
						<!-- <el-button type="warning" size="mini" @click="openPopup"
							>View Daily</el-button
						> -->
						<el-select
							v-model="store_name"
							style="max-width: 180px"
							size="mini"
							placeholder="Select Store"
						>
							<el-option
								v-for="(item, index) in store_list"
								:key="index"
								:value="item.id"
								:label="item.name"
							>
								{{ item.name }}
							</el-option>
						</el-select>
					</div>
					<SingleLunchGraph :graph-details="graphDetails" />
					<div class="text-right bg-grey-light p-2">
						<el-button type="warning" size="mini" @click="openTable('week')">{{
							weekTable ? "Hide" : "View Details"
						}}</el-button>
					</div>
				</div>
				<div class="text-right">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</el-col>
			<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="lunch">
					<div class="">
						<p class="text-xs pt-4 pl-4">Month - April 2020</p>
						<div class="flex justify-between items-center mt-4">
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Sales</p>
								<p class="font-bold">64,902</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker text-">Target</p>
								<p class="font-bold">64,902</p>
							</div>
							<div class="text-center card-title mx-4">
								<p class="text-grey-darker">&nbsp;</p>
								<p class="font-bold">
									87%
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="graph-heading">
						<p class="heading">Month - April 2020</p>
						<!-- <el-button type="warning" size="mini" @click="openPopup"
							>View Weekly</el-button
						> -->
						<el-select
							v-model="store_name"
							style="max-width: 180px"
							size="mini"
							placeholder="Select Store"
						>
							<el-option
								v-for="(item, index) in store_list"
								:key="index"
								:value="item.id"
								:label="item.name"
							>
								{{ item.name }}
							</el-option>
						</el-select>
					</div>
					<SingleLunchGraph :graph-details="graphDetails" />
					<div class="text-right bg-grey-light p-2">
						<el-button type="warning" size="mini" @click="openTable('month')">{{
							monthTable ? "Hide" : "View Details"
						}}</el-button>
					</div>
				</div>
				<div class="text-right">
					<el-pagination background layout="prev, pager, next" :total="1">
					</el-pagination>
				</div>
			</el-col>
		</el-row>
		<div v-if="weekTable || monthTable" class="card">
			<div class="graph-heading p-2">
				<p class="heading">Day - {{ today }}</p>
			</div>
			<table class="table">
				<thead>
					<tr>
						<th>Store Name</th>
						<th>Sales</th>
						<th>Forecast</th>
						<th>Target</th>
						<th>Last Period</th>
						<th>Achievement</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td style="font-weight: bold">Total</td>
						<td>12,052</td>
						<td>10,000</td>
						<td>8523</td>
						<td>13.451</td>
						<td>120.05%</td>
					</tr>
					<tr v-for="(item, index) in graphDetails" :key="index">
						<td style="color: #2c9bce; font-weight: bold">{{ item.name }}</td>
						<td>12,052</td>
						<td>10,000</td>
						<td>8523</td>
						<td>13.451</td>
						<td>120.05%</td>
					</tr>
				</tbody>
			</table>
		</div>
		<el-dialog
			title="Hourly Graph"
			:visible.sync="hourlyPopup"
			width="60%"
			:before-close="handleClose"
		>
			<div class="flex justify-center">
				<el-button type="warning" size="mini">Sales</el-button>
				<el-button type="warning" size="mini">Transactions</el-button>
				<el-button type="warning" size="mini">Gross Margin</el-button>
			</div>
			<SingleDayGraph />
		</el-dialog>
	</div>
</template>
<script>
import moment from "moment";
import SingleLunchGraph from "../singleStoreGraph/SingleLuncheGraph.vue";
import SingleDayGraph from "../singleStoreGraph/singleDayGraph.vue";
// import SingleWeekGraph from "../singleStoreGraph/singleWeekGraph.vue";
// import SingleMonthGraph from "../singleStoreGraph/singleMonthGraph.vue";

export default {
	name: "MultipleStoreData",
	components: {
		SingleLunchGraph,
		SingleDayGraph
		// SingleWeekGraph,
		// SingleMonthGraph
	},
	data() {
		return {
			today: moment(new Date()).format("dddd, Do MMMM YYYY"),
			date: "",
			hourlyPopup: false,
			lunchTable: false,
			weekTable: false,
			monthTable: false,
			dayTable: false,
			detailsTable: false,
			store_name: "",
			store_list: [],
			graphDetails: [
				{ name: "Ford" },
				{ name: "Nirmal" },
				{ name: "Ram Mahel" },
				{ name: "Kemps Corner" },
				{ name: "Atria Mall" }
			]
		};
	},
	created() {},
	methods: {
		openPopup() {
			this.hourlyPopup = true;
		},
		openTable(value) {
			if (value == "lunch") {
				this.lunchTable = !this.lunchTable;
				this.dayTable = false;
			} else if (value == "day") {
				this.dayTable = !this.dayTable;
				this.lunchTable = false;
			} else if (value == "week") {
				this.weekTable = !this.weekTable;
				this.monthTable = false;
			} else if (value == "month") {
				this.monthTable = !this.monthTable;
				this.weekTable = false;
			}
		},
		handleClose() {
			this.hourlyPopup = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./MultipleStoreData.scss";
</style>
<style>
.AppLayout {
	/* background: #ffffff !important; */
	overflow: auto;
}
.multipleStoreData .el-dialog {
	/* width: 40%; */
	margin-top: 50px !important;
}
.multipleStoreData .el-dialog__header {
	background: #32343d;
}
.multipleStoreData .el-dialog__title {
	color: white;
	font-size: 15px;
	/* font-weight: 600; */
}
</style>
